import React from 'react';

const Comp = () => <div />;

export const presentEventCreatingDialog = () => Promise.resolve(true);

export default Comp;
